import { CONNECTOR_TYPES } from '@/vars/general'
import store from '@/store'

const BeautyAutopilot = () => import('./views/BeautyAutopilot.vue')
const TaskLibrary = () => import('./views/TaskLibrary.vue')

const routeGuard = (to, from, next) => {
    const checkAccess = () => {
        const project = store.getters.projectById(to.params.id)
        if (!project) {
            next('/projects')
            return
        }
        const enabled = project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)
            ?.showBeautyAutopilot
        if (enabled) {
            next()
        } else {
            next('/projects')
        }
    }

    // Если проекты еще загружаются, ждем завершения загрузки
    if (store.state.isProjectsLoading) {
        const unwatch = store.watch(
            (state) => state.isProjectsLoading,
            (isLoading) => {
                if (!isLoading) {
                    unwatch()
                    checkAccess()
                }
            },
            { immediate: true }
        )
    } else {
        checkAccess()
    }
}

export default [
    {
        path: '/project/:id/GCB2/BeautyAutopilot',
        name: 'BeautyAutopilot',
        component: BeautyAutopilot,
        beforeEnter: routeGuard,
    },
    {
        path: '/project/:id/GCB2/BeautyAutopilot/task-library',
        name: 'BeautyAutopilotTaskLibrary',
        component: TaskLibrary,
        beforeEnter: routeGuard,
    },
]
